import { ItemsSettingsFormFields } from './ItemsSettingsForm.types'

export const ITEM_TAX_APPLICABLE_FIELD = 'isTaxApplicable'
export const ITEM_TAX_INCLUSIVE_FIELD = 'isTaxInclusive'

export const initialValues: ItemsSettingsFormFields = {
  [ITEM_TAX_APPLICABLE_FIELD]: false,
  [ITEM_TAX_INCLUSIVE_FIELD]: false,
}
